export default __webpack_public_path__ + "static/media/quieroreservar.6ab95969.png";